import VisibilityIcon from "@material-ui/icons/Visibility";
import AddCircleIcon from '@material-ui/icons/AddCircle';
import CancelIcon from "@material-ui/icons/Cancel";
import React from "react";
import {faUpload} from "@fortawesome/free-solid-svg-icons/faUpload";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";

export default {
    tableActionButton:{
        inquiry:{
            className: 'btn-primary',
            icon: <VisibilityIcon />,
            id: 'MEDCAL_RX_VIEW_PA_BUTTON',
            text: 'View',
            operation: 'inquiry',
            tooltip: 'View PA',
        },
        update:{
            className: 'btn-secondary',
            icon: <AddCircleIcon />,
            text: 'Add Info',
            tooltip: 'Add Info',
            operation: 'update',
            id: 'MEDCAL_RX_ADD_INFO_BUTTON'
        },
        cancel: {
            className: 'btn-primary',
            text: 'Cancel',
            icon: <CancelIcon />,
            tooltip: 'Cancel PA',
            operation: 'cancel',
            id: 'MEDCAL_RX_CANCEL_PA_BUTTON'
        },
        upload: {
            className: 'btn-primary',
            icon: <FontAwesomeIcon icon={faUpload} />,
            text: 'Upload',
            tooltip: 'Upload Attachments',
            operation: 'upload',
            id: 'MEDCAL_RX_UPLOAD_PA_BUTTON'
        }
    },
    clickText: 'View Response'
};
